import {GET_TICKER} from '../types'



const initialState = {
    symbol:'BTCUSDT',
    priceChange:null,
    priceChangePercent:null,
    weightedAvgPrice:null,
    prevClosePrice:null,
    lastPrice:null,
    lastQty:null,
    bidPrice:null,
    bidQty:null,
    askPrice:null,
    askQty:null,
    openPrice:null,
    highPrice:null,
    lowPrice:null,
    volume:null,
    quoteVolume:null,
    openTime:null,
    closeTime:null,
    firstId:null,
    lastId:null,
    count:null,
}

export default function(state = initialState, action){

    switch(action.type){

        case GET_TICKER:
            return {
                ...state,
                ...action.payload,

            }
        default: return state
    }

}
